// Pack for pages with legacy scripts

import { registerEventHandlers } from "@/bl-events"

import "@/modules/base"
import "@/modules/legacy"
import "@/modules/signup-social-toggle"
import { wdyhauEventHandlers, setWdyhauTrafficCookie } from "@/modules/wdyhau-survey"
import "@/modules/abtest-body-class"
import { eventHandlers as abTestEventHandlers } from "@/modules/abtest-toggle"
import "@/modules/asynch-ab-tests-ready"
import "@/modules/active-between"
import "@/modules/slider"
import "@/modules/scroll-to-anchor"
import "@/modules/lazyload"

import initSmartbanner from "@/features/smartbanner/init"
import initHeader from "@/features/header/header"
import initForgotPassword from "@/features/forgot-password/init"
import "@/features/settings/init"
import "@/features/book-card-audio/init"
import "@/features/notifications/init"
import mountToaster from "@/features/toaster/mount"
import "@/features/internal-links-section/init"
import initPosthog from "@/features/posthog/init"
import initDatadogRUM from "@/features/datadog-rum/init"

import "@/pages/email-preferences/init"
import "@/pages/signup-page/init"

import "@/styles/app.scss"

registerEventHandlers([
  wdyhauEventHandlers,
  abTestEventHandlers,
  {
    "setup:ready": (config) => {
      initSmartbanner(config)
    }
  }
])

initHeader()
setWdyhauTrafficCookie()
initForgotPassword()
initPosthog()
initDatadogRUM()
mountToaster()
